"use strict";

exports.__esModule = true;
exports.commentsDefinition = void 0;
var commentsDefinition = exports.commentsDefinition = function commentsDefinition(translate) {
  return {
    columns: [{
      id: "deviceName",
      name: translate("DataTable.Column.Title.deviceName", "Device"),
      type: "deviceName",
      canFilter: true,
      showSearchFilter: false
    }, {
      id: "createdMillis",
      name: translate("DataTable.Column.Title.createdMillis", "Created At"),
      type: "date",
      canFilter: true,
      showSearchFilter: true,
      usePlantTime: true
    }, {
      id: "author",
      name: translate("DataTable.Column.Title.author", "Created By"),
      type: "author",
      canFilter: true
    }, {
      id: "body",
      name: translate("DataTable.Column.Title.body", "Comment"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "editedTimestamp",
      name: translate("DataTable.Column.Title.editedAt", "Edited At"),
      type: "date",
      canFilter: true,
      showSearchFilter: true,
      usePlantTime: true
    }, {
      id: "editedBy",
      name: translate("DataTable.Column.Title.editedBy", "Edited By"),
      type: "author",
      canFilter: true
    }, {
      id: "state",
      name: translate("DataTable.Column.Title.state", "State"),
      type: "state",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "activity",
      name: translate("DataTable.Column.Title.activity", "Activity"),
      type: "activity",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "shift",
      name: translate("DataTable.Column.Title.shift", "Shift"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "partKind",
      name: translate("DataTable.Column.Title.partKind", "Part Kind"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "operator",
      name: translate("DataTable.Column.Title.operator", "Operator"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "conditionLevel",
      name: translate("DataTable.Column.Title.conditionLevel", "Condition Level"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "conditionText",
      name: translate("DataTable.Column.Title.conditionText", "Condition Text"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "nativeCode",
      name: translate("DataTable.Column.Title.nativeCode", "Native Code"),
      type: "string",
      canFilter: true,
      showSearchFilter: true
    }],
    parseData: function parseData(responseData) {
      return {
        deviceId: responseData.deviceUuid,
        deviceName: responseData.deviceUuid,
        id: responseData.commentId,
        author: responseData.author,
        body: responseData.body,
        editedTimestamp: responseData.editedTimestamp,
        editedBy: responseData.editedBy,
        createdMillis: responseData.createdMillis,
        duration: responseData.duration,
        start: responseData.interval.startMillis,
        end: responseData.interval.endMillis,
        state: responseData.state,
        activity: responseData.activity,
        shift: responseData.shift,
        partKind: responseData.partKind,
        operator: responseData.operator,
        conditionLevel: responseData.conditionLevel,
        conditionText: responseData.conditionText,
        nativeCode: responseData.nativeCode
      };
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: true,
        defaultPageSize: "auto",
        columns: [{
          id: "deviceName",
          name: translate("DataTable.Column.Title.deviceName", "Device"),
          type: "deviceName",
          enableSorting: true
        }, {
          id: "createdMillis",
          name: translate("DataTable.Column.Title.createdMillis", "Created At"),
          type: "date",
          canFilter: true,
          showSearchFilter: true,
          enableSorting: true,
          usePlantTime: true
        }, {
          id: "author",
          name: translate("DataTable.Column.Title.author", "Created By"),
          type: "author",
          enableSorting: true
        }, {
          id: "body",
          name: translate("DataTable.Column.Title.body", "Comment"),
          type: "string",
          enableSorting: false
        }]
      };
    }
  };
};